export default {
    'Home': 'หน้าแรก',
    'Your Profile':'โปรไฟล์ของฉัน',
    'My name is':'ฉันชื่อ...',
    'I\'m a':'ฉันเป็น',
    'Surname':'ชื่อ',
    'Lastname':'นามสกุล',
    'Create your':'สร้างบัญชี',
    'new account':'ใหม่ของคุณ',
    'Start':'เริ่ม',
    'Continue':'ถัดไป',
    'Sex':'เพศ',
    'Man':'ชาย',
    'Woman':'หญิง',
    'My age':'อายุของฉัน',
    'Age':'อายุ',
    'years old':'ปี',
    'My height':'ขนาดของฉัน',
    'Height':'ขนาด',
    'My weight':'น้ำหนักของฉัน',
    'Weight':'น้ำหนัก',
    'My body':'ร่างกายของฉัน',
    'Body':'ร่างกาย',
    'Skinny':'ผอม',
    'Average':'สมส่วน',
    'Corpulent':'อ้วนท้วม',
    'Muscular':'มีกล้าม',
    'BRSkinny':'ผอม',
    'BRAverage':'สมส่วน',
    'BRCorpulent':'ตุ้ยนุ้ย',
    'BRMuscular':'บ้ากล้าม',
    'My goal':'เป้าหมายของฉัน',
    'Goal':'เป้าหมาย',
    'Health':'สุขภาพ',
    'Endurance':'ความอดทน',
    'Appearance':'Looks',
    'Strength':'ความแข็งแรง',
    'BRHealth':'สุขภาพ',
    'BREndurance':'หยุด',
    'BRAppearance':'ระวัง',
    'BRStrength':'ความแข็งแรง',
    'Skip':'ข้าม',
    'T&C':'ข้อกำหนดและเงื่อนไข',
    'Imprint':'Masthead',
    'Help':'ความช่วยเหลือ',
    'Deactivation':'การบริหารการสมัครสมาชิก',
    'Profile':'โปรไฟล์',
    'Training':'การอบรม',
    'Eating plan':'แผนอาหาร',
    'Statisitc':'สถิติ',
    'Payment':'การชำระเงิน',
    'Settings':'การตั้งค่า',
    'Save':'บันทึก',
    'Training Days':'วันฝึก',
    'Days':'วัน',
    'Streak':'ความต่อเนื่อง',
    'Points':'จุด',
    'Finished Workouts':'ออกกำลังกายสำเร็จ',
    'Workouts':'ออกกำลังกาย',
    'O from M':'{O} จาก {M}',
    'Record':'ประสิทธิภาพที่ดีที่สุด',
    'Complete training time':'เสร็จสิ้นเวลาการฝึกฝน',
    'W workouts with R repetitions':'{W} ออกกำลังกายด้วย {R} การทำซ้ำ',
    'workouts with':'ออกกำลังกายกับด้วย',
    'repetitions':'การทำซ้ำ',
    'S km stretch':'การวิ่งติดต่อกันจาก {S} กม.',
    'Take a break':'พักได้',
    'Begin':'ไปเลย',
    'Day':'วัน',
    'Breakfast':'อาหารเช้า',
    'Dinner':'อาหารเที่ยง',
    'Supper':'อาหารเย็น',
    'Duration':'ระยะเวลา',
    'Repetitions with B sec break':'การทำซ้ำพร้อมกับหยุดพัก {B} วินาที',
    'Difficulty':'ความยาก',
    'low':'ง่าย',
    'middle':'ปานกลาง',
    'high':'ขึ้น',
    'You made 1 Day':'คุณทำจบไปหนึ่งวันแล้ว',
    'SUPER WORKOUT!':'ซุปเปอร์เวิร์คเอาท์!',
    'With protein for training success':'โปรตีนสำหรับการฝึกฝนสำเร็จ',
    'Search':'ค้นหา',
    'Cancel':'ออก',
    'Snacks':'ขนมขบเคี้ยว',
    'Vegan':'วีแกน',
    'Lunch':'อาหารเที่ยง',
    'Drink':'ดื่ม',
    'Search terms':'คำสำคัญ',
    'The transaction was successful. Thank you for using the service.':'การทำธุรกรรมสำเร็จ ขอบคุณที่ใช้บริการ',
    'You will be redirected to the site in a moment. If this does not happen in a few seconds, click Next.':'คุณจะถูกนำไปยังเว็บไซต์ในช้า หากไม่มีอะไรเกิดขึ้นภายในไม่กี่วินาทีนี้ คลิก ถัดไป',
    'Pin could not be confirmed, please try again.':'ไม่สามารถยืนยันพินได้ โปรดลองใหม่อีกครั้ง',
    'Ingredients':'ส่วนผสม',
    'Preparation':'การเตรียม',
    'Portions':'แชร์',
    'Contact': 'ติดต่อ',
    'Privacy': 'ความเป็นส่วนตัว',
    'Wrong Pin. Please check your SMS box.': 'พินผิด กรุณาตรวจสอบกล่อง SMS ของคุณ',
    'Wrong Pin. Please check your SMS box': 'พินผิด กรุณาตรวจสอบกล่อง SMS ของคุณ',
    'Write MSISDN to login': 'เขียน MSISDN เพื่อเข้าสู่ระบบ',
    'Easy': 'ง่าย',
    'Normal': 'ปกติ',
    'Hard': 'ยาก',
    'More': 'มากกว่า',
    'See more workouts': 'ดูการออกกำลังกายเพิ่มเติม',
    'Workouts List': 'รายการออกกำลังกาย',
    'Individual exercises': 'แบบฝึกหัดส่วนบุคคล',
    'Start training': 'เริ่มการฝึก'
}


// WEBPACK FOOTER //
// ./src/i18n/th.js